import { defineComponent as _defineComponent } from 'vue'
import CcAlert from '@/views/Automation/CampaignCreatorV2/components/CcAlert/CcAlert.ts.vue';
import { ErrorData, FieldVariable } from '@/views/Automation/CampaignCreatorV2/store/AbVariables';
import { ErrorType } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CcError.ts',
  props: {
    errors: null,
    field: null,
    variableId: null,
    abGroup: null
  },
  setup(__props: any) {

const props = __props as {
  errors?: ErrorData<any, any, any>[];
  field?: FieldVariable<any, any>;
  variableId?: string;
  abGroup?: string;
};



const variable = computed(() => {
  if (props.variableId && props.abGroup) {
    return props.field?.value?.find((e) => e.variableId === props.variableId && e.abGroup === props.abGroup);
  }
  return props.field?.value?.[0];
});

const fieldErrors = computed(() => [...(variable.value?.errors || props.field?.errors || [])]);

const errors = computed(() => [(props.errors?.filter(Boolean) || []).concat(fieldErrors.value)].flat());

const hasErrors = computed(
  () => errors?.value.length && errors?.value.some((error) => error.type !== ErrorType.SILENT)
);

return { __sfc: true,props, variable, fieldErrors, errors, hasErrors, CcAlert }
}

})